import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-calendar', 'weekDays', [
    'Пн',
    'Вт',
    'Ср',
    'Чт',
    'Пт',
    'Сб',
    'Вс',
]);
Labels.set('ui-calendar', 'weekDaysLong', [
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
    'Воскресенье',
]);
Labels.set('ui-calendar', 'prevMonth', 'Предыдущий месяц');
Labels.set('ui-calendar', 'nextMonth', 'Следующий месяц');
Labels.set(
    'ui-calendar',
    'arrowKeys',
    'Клавиши со стрелками могут перемещать по датам'
);
